import { ActionType, createReducer } from 'typesafe-actions';
import * as actions from 'store/actions/tickets';
import { TicketsResponse } from 'store/types/tickets';

const initialState: Array<TicketsResponse> = [];

export const TicketsReducer = createReducer<Array<TicketsResponse>, ActionType<typeof actions>>(
  initialState,
).handleAction(actions.getAllTickets.success, (state, { payload }) => ({
  ...state,
  ...payload,
}));

export const TicketsDetailsReducer = createReducer<Array<TicketsResponse>, ActionType<typeof actions>>(
  initialState,
).handleAction(actions.getDetailsTicket.success, (state, { payload }) => ({
  ...state,
  ...payload,
}));
